import { ajax } from '@fosterburg/common-ui/utils/ajax';
import { prefix } from './prefix';

export async function getSermons(page = 1) {
  const response = await ajax({
    url: prefix + '/sermons',
    data: {
      page,
    },
  });

  const sermons = await response.json();

  return sermons;
}

export async function getSermon(id) {
  const response = await ajax({
    url: prefix + '/sermons/' + id,
  });

  const sermons = await response.json();

  return sermons;
}
